import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import pl from "./locales/pl.json";
import zh from "./locales/zh.json";

export const SUPPORTED_LANGUAGES = ["en", "pl", "zh"] as const;
export type SupportedLang = (typeof SUPPORTED_LANGUAGES)[number];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      pl: { translation: pl },
      zh: { translation: zh },
    },
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES,
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: {
      order: ["querystring", "localStorage", "navigator", "htmlTag"],
      lookupQuerystring: "lang",
      lookupLocalStorage: "prec-language",
      caches: ["localStorage"],
    },
    returnObjects: true,
  });

if (typeof document !== "undefined") {
  document.documentElement.lang = i18n.language?.split("-")[0] || "en";
  i18n.on("languageChanged", (lng) => {
    document.documentElement.lang = lng.split("-")[0];
  });
}

export default i18n;
